<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="flex flex-wrap filter_blocks">
          <div class="form-group">
            <label>Период отчета</label>
            <div class="input-group">
              <DateSelect
                ref="dateFrom"
                :selectedDate="preset.date.from"
              />
              <div class="input-group-prepend input-group-append">
                <span class="input-group-text">по</span>
              </div>
              <DateSelect
                ref="dateTo"
                :selectedDate="preset.date.to"
              />
            </div>
          </div>
          <div class="form-group flex-grow-1">
            <label>Причина отмены через ","</label>
            <input type="text" v-model="filter.rejectWords" class="form-control">
          </div>
        </div>
        <div class="mt-1">
          <div><label><input type="radio" value="none" v-model="filter.groupBy"> не группировать</label></div>
          <div><label><input type="radio" value="city" v-model="filter.groupBy"> группировать по городам</label></div>
          <div><label><input type="radio" value="drug" v-model="filter.groupBy"> группировать по препарату</label></div>
        </div>
        <div class="flex filter_blocks justify-content-between">
          <div class="flex filter_blocks">
            <div class="form-group">
              <label>Города</label>
              <multiselect
                v-model="filter.selectedCities"
                :options="$AllCities"
                @input="(t) => {}"
                placeholder="Выберите города"
                track-by="id"
                label="short_name"
                :searchable="true"
                :multiple="true">
                <template slot="noResult">Город не найден</template>
              </multiselect>
            </div>
            <div class="form-group">
              <label>Игнорировать города</label>
              <multiselect
                v-model="filter.ignoredCities"
                :options="$AllCities"
                @input="(t) => {}"
                placeholder="Выберите города"
                track-by="id"
                label="short_name"
                :searchable="true"
                :multiple="true">
                <template slot="noResult">Город не найден</template>
              </multiselect>
            </div>
            <div class="form-group">
              <label>Типы отмены</label>
              <multiselect
                v-model="filter.reject_types"
                :options="$platformConstants.orderRejectReasons"
                @input="(t) => {}"
                placeholder="Выберите причину"
                track-by="id"
                label="title"
                :searchable="true"
                :multiple="true">
                <template slot="noResult">Причина не найдена</template>
              </multiselect>
            </div>
          </div>
          <div class="align-self-end">
            <LoadingButton
              title="Показать"
              type="button"
              :loading="loading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => getRecords(1)"
              className="btn btn-outline-info"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="records !== null">
      <div class="card-body">
        <div v-if="paginator" class="flex justify-content-between">
          <span>Всего записей: <strong>{{ paginator.total }}</strong></span>
          <paginate
            v-model="paginator.current_page"
            :page-count="paginator.last_page"
            :page-range="8"
            :margin-pages="2"
            :click-handler="getRecords"
            :prev-text="'&laquo'"
            :next-text="'&raquo'"
            :container-class="'pagination'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
            :active-class="'active green_btn'">
          </paginate>
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading">
          <table class="table table-sm mt-1 table-hover table-striped">
            <template v-if="selectedType === 'drug'">
              <thead>
              <tr>
                <td></td>
                <td>Препарат</td>
                <td>Заявок</td>
                <td>Кол.</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(r,i) in records" :key="r.id">
                <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
                <td>({{ r.drug_id }}) {{ r.drug_title }}</td>
                <td>{{ r.total }}</td>
                <td>{{ Math.round(r.total_drugs) }}</td>
              </tr>
              </tbody>
            </template>
            <template v-if="selectedType === 'city'">
              <thead>
              <tr>
                <th>Город</th>
                <th>Препарат</th>
                <th>Кол.</th>
                <th>Склад</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(rr, cityId, i) in records" v-if="rr.length">
                <tr>
                  <td :rowspan="rr.length + 1">{{ getCityName(cityId) }}</td>
                </tr>
                <tr v-for="(r,ii) in sortRecords(rr, 'total_drugs')" :key="r.id">
                  <td>({{ r.drug_id }}) {{ r.drug_title }}</td>
                  <td>{{ Math.round(r.total_drugs) }}</td>
                  <td>
                    <scale-loader :loading="storeLoading" height="12px"/>
                    <template v-if="!storeLoading">
                      <p>на складе: <strong>{{ printStoreData(r.drug_id, cityId, 'store') }}</strong></p>
                      <p>на мск: <strong>{{ printStoreData(r.drug_id, cityId, 'top') }}</strong></p>
                      <p>продажа за 30 дней: <strong>{{ soldData?.[r.drug_id]?.[cityId] ?? 0 }}</strong></p>
                      <p>достаточно на :
                        <strong>{{ Math.round(+printStoreData(r.drug_id, cityId, 'top') * 30 / (soldData?.[r.drug_id]?.[cityId] ?? 1)) }}</strong>
                        дней</p>
                    </template>
                  </td>
                </tr>
              </template>
              </tbody>
            </template>
            <template v-if="selectedType === 'none'">
              <thead>
              <tr>
                <td></td>
                <td>Заявка</td>
                <td>Препараты</td>
                <td>Отмена</td>
                <td>Сумма</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(r,i) in records" :key="r.id">
                <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
                <td>
                  <div class="flex">
                    <button
                      @click="openOrderInModal(r.id)"
                      class="btn btn-xs btn-info mr-1">
                      <i class="icon-fa icon-fa-eye"></i>
                    </button>
                    {{ r.id }}
                  </div>
                </td>
                <td>
                  <p v-for="d in r.details">({{ d.drug_id }}) {{ d.drug.title }} x <strong>{{ d.qty }}</strong> x
                    <strong>{{ d.price }}</strong></p>
                </td>
                <td>{{ r.reject_comment }}</td>
                <td><strong>{{ r.price }}</strong></td>
              </tr>
              </tbody>
            </template>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import DateSelect from "@/views/reports/components/DateSelect.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import moment from "moment";
import Multiselect from 'vue-multiselect'
import Paginate from 'vuejs-paginate'

export default {
  title: 'Статистика',
  components: {LoadingButton, DateSelect, Multiselect, Paginate},
  data() {
    return {
      loading: false,
      storeLoading: false,
      records: null,
      paginator: null,
      inStores: {},
      topStores: {},
      soldData: {},
      citiesToStores: {},
      preset: {
        date: {
          from: moment().subtract(1, 'month').format('DD.MM.YYYY'),
          to: moment().format('DD.MM.YYYY')
        }
      },
      selectedType: null,
      filter: {
        date: {
          from: null,
          to: null,
        },
        groupBy: 'none',
        reject_types: [],
        selectedCities: [],
        ignoredCities: [],
        rejectWords: 'ждать,поздно,срочно,долго,налич,ожид,актуально,купил,нет препарата'
      }
    }
  }, computed: {
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
  },
  methods: {
    printStoreData(drugId, cityId, type) {
      switch (type) {
        case 'store':
          return Object.values(this.citiesToStores[cityId]).reduce((acc, storeId) => acc + (this.inStores[drugId]?.[storeId] ?? 0), 0);
        case 'top':
          // return Object.values(this.citiesToStores[cityId]).reduce((acc, storeId) => acc + (this.topStores[drugId]?.[storeId] ?? 0), 0);
          return this.topStores[drugId]?.[Object.values(this.citiesToStores[cityId])?.[0]] ?? 0;
      }
    },
    sortRecords(records, field) {
      return _.orderBy(records, field, 'desc');
    },
    getCityName(cityId) {
      return this.$AllCities.find((c) => c.id === +cityId)?.short_name ?? cityId;
    },
    openOrderInModal(orderId) {
      this.$store.dispatch('orders/setOrderToEdit', {orderId: orderId})
    },
    printDrug(record) {
      const drugRecord = record.details.find((d) => d.drug_id === record.drug_id);
      return drugRecord?.drug?.title ?? 'not_found';
    },
    async getStoreData() {
      this.storeLoading = true;
      const {data} = await api.post('/stores/actualStoreData', {
        drugsIds: Object.values(this.records).reduce((acc, s) => [...new Set([...acc, ...s.map((d) => d.drug_id)])], []),
        citiesIds: Object.keys(this.records)
      });
      if (data.success) {
        this.citiesToStores = data.citiesToStores;
        this.soldData = data.soldData;
        this.inStores = data.inStores;
        this.topStores = data.topStores;
      }
      this.storeLoading = false;
    },
    async getRecords(page = 1) {
      this.loading = true;
      this.filter.date.from = this.$refs.dateFrom.date;
      this.filter.date.to = this.$refs.dateTo.date;
      const filter = {...this.filter};
      filter.selectedCities = filter.selectedCities.map((s) => s.id);
      filter.ignoredCities = filter.ignoredCities.map((s) => s.id);
      filter.reject_types = filter.reject_types.map((s) => s.id);
      this.selectedType = filter.groupBy;
      this.records = [];
      const {data: r_data} = await api.post('/statistics/orders/rejected?page=' + page, {
        filter
      })
      if (r_data.success) {
        if (r_data.records.data) {
          const {data, ...pagination} = r_data.records;
          this.paginator = pagination;
          this.records = data;
        } else {
          this.paginator = null;
          this.records = r_data.records;
          if (this.selectedType === 'city') {
            this.getStoreData();
          }
        }
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.filter_blocks.flex {
  gap: 5px;
}

.form-group {
  margin-bottom: 0;
}
</style>
